"use strict";
/// <reference path="./Graph.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const KendoLayout_1 = require("./Layout/KendoLayout");
const LayoutBase_1 = require("./Layout/LayoutBase");
const Organigramm_1 = require("./Layout/Organigramm");
const $ = require("jquery");
const Instance_1 = require("../../model/Instance");
class Graph {
    static init($elem, options) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = $this.data("synGraph");
            if (!synData) {
                $this.data("synGraph", $.extend(true, {
                    layoutType: LayoutBase_1.GraphLayoutType.Layered,
                    showIcons: true,
                    showDetails: true,
                    multiLineTitle: false,
                    nodeWidth: 300,
                    colors: {
                        node: {
                            text: "#000",
                            border: "#000",
                            borderHover: "#000",
                            borderSelected: "#000",
                            background: "#c7d5dd",
                            backgroundCenter: "#ffa500",
                            backgroundHover: "#9fcf9e",
                            backgroundSelected: "#00ff65",
                            groupBorder: "#000"
                        },
                        edge: {
                            stroke: "#000",
                            strokeHover: "#9fcf9e",
                            strokeSelected: "#00ff65",
                            label: "#000",
                            labelHover: "#9fcf9e",
                            labelSelected: "#00ff65"
                        }
                    },
                    parentDepth: 1,
                    childDepth: 0,
                    allowedCategories: undefined,
                    allowedRelIds: undefined,
                    fetchUncles: false
                }, options));
                synData = $this.data("synGraph");
                $this.trigger("beginInit");
                $this.addClass("synGraph");
                $this.kendoDiagram({
                    zoomMax: 5,
                    zoomMin: 0.1,
                    zoomRate: 0.2,
                    mouseEnter: (evt) => {
                        const layout = $this.data("layout");
                        if (layout && evt.item) {
                            if (typeof evt.item.sourceConnector !== "undefined" && typeof evt.item.targetConnector !== "undefined")
                                layout.mouseEnterConnection(evt.item);
                            else if (typeof evt.item.shapeVisual !== "undefined" && typeof evt.item.connectors !== "undefined")
                                layout.mouseEnterShape(evt.item);
                            else if (evt.item)
                                layout.mouseEnterMisc(evt.item);
                        }
                    },
                    mouseLeave: (evt) => {
                        const layout = $this.data("layout");
                        if (layout && evt.item) {
                            if (typeof evt.item.sourceConnector !== "undefined" && typeof evt.item.targetConnector !== "undefined")
                                layout.mouseLeaveShape(evt.item);
                            else if (typeof evt.item.shapeVisual !== "undefined" && typeof evt.item.connectors !== "undefined")
                                layout.mouseLeaveShape(evt.item);
                            else if (evt.item)
                                layout.mouseLeaveMisc(evt.item);
                        }
                    },
                    editable: false,
                    selectable: false,
                    zoomStart(e) {
                        var _a, _b, _c;
                        // Double click seems to be hardwired to zoom in kendo Diagram, but we have a zoomStart
                        // event which we can hijack to get our doubleClick behavior (graph navigation)
                        if ("doubleTap" === ((_b = (_a = e) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.type)) {
                            const diagram = $this.getKendoDiagram();
                            const posX = e.point.x;
                            const posY = e.point.y;
                            // In this event, we don't have the shape data, so we have to enumerate the shapes and
                            // for each shape, get its bounding box to determine which shape the mouse is currently
                            // over
                            for (let i = 0; i < diagram.shapes.length; ++i) {
                                const shape = diagram.shapes[i];
                                const instance = (_c = shape.dataItem) === null || _c === void 0 ? void 0 : _c.instance;
                                if (typeof instance !== "undefined" && instance.id) {
                                    const bbox = diagram.boundingBox(shape);
                                    if (posX >= bbox.x && posX <= bbox.x + bbox.width && posY >= bbox.y && posY <= bbox.y + bbox.height) {
                                        $this.trigger("nodeDoubleClicked", [instance.id.value]);
                                        break;
                                    }
                                }
                            }
                            e.preventDefault();
                        }
                    },
                    click(e) {
                        if (e.item instanceof kendo.dataviz.diagram.Shape) {
                            // node clicked
                            let instance = e.item.dataItem.instance;
                            if (typeof instance !== "undefined" && instance.id) {
                                $this.getKendoDiagram().select(e.item);
                                $this.trigger("graphNodeSelected", [instance.id.value]);
                            }
                            else
                                e.sender.select(false);
                        }
                    }
                });
                $this.getKendoDiagram().scroller.enabled = true;
                Graph.resize($this);
                $this.trigger("initSuccess");
                $this.trigger("endInit");
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            $(this).off("beginInit")
                .off("categoriesReceived")
                .off("initSuccess")
                .off("initFailed")
                .off("endInit")
                .off("categorySelected")
                .removeData("synGraph");
        });
    }
    static resize($elem) {
        return $elem.each(function () {
            let $this = $(this);
            $this.getKendoDiagram().resize();
            $this.find('.km-scroll-wrapper').css("width", $this.innerWidth() + "px");
            $this.find('.km-scroll-wrapper').css("height", $this.innerHeight() + "px");
        });
    }
    static navigateTo($elem, id, forceRefresh = false) {
        return $elem.each(function () {
            let $this = $(this);
            let oldCenterNode = $this.data("centerNode");
            if (id) {
                $this.data("centerNode", id);
                Graph.updateGraph($this, id, forceRefresh || id !== oldCenterNode);
            }
            else
                Graph.updateGraph($this, oldCenterNode, false);
        });
    }
    static redrawGraph($elem, refetch) {
        return $elem.each(function () {
            let $this = $(this);
            let centerNode = $this.data("centerNode");
            if (centerNode)
                Graph.updateGraph($this, centerNode, refetch);
        });
    }
    static clearGraph($elem) {
        const diagram = $elem.getKendoDiagram();
        if (diagram)
            diagram.clear();
    }
    static setOptions($elem, options, noRefresh = false) {
        return $elem.each(function () {
            let $this = $(this);
            let oldOptions = $this.data("synGraph");
            let refetch = false;
            if (typeof options.allowedCategories !== "undefined" && !Graph.arraysAreEqual(oldOptions.allowedCategories, options.allowedCategories))
                refetch = true;
            else if (typeof options.allowedRelIds !== "undefined" && !Graph.arraysAreEqual(oldOptions.allowedRelIds, options.allowedRelIds))
                refetch = true;
            else if (typeof options.parentDepth !== "undefined" && oldOptions.parentDepth !== options.parentDepth)
                refetch = true;
            else if (typeof options.childDepth !== "undefined" && oldOptions.childDepth !== options.childDepth)
                refetch = true;
            else if (typeof options.fetchUncles !== "undefined" && oldOptions.fetchUncles !== options.fetchUncles)
                refetch = true;
            else if (typeof options.layoutType !== "undefined" && oldOptions.layoutType !== LayoutBase_1.GraphLayoutType.TdOrganigram && options.layoutType === LayoutBase_1.GraphLayoutType.TdOrganigram)
                refetch = true;
            $.extend(oldOptions, options);
            if (!noRefresh)
                Graph.redrawGraph($this, refetch);
        });
    }
    static getOptions($elem) {
        return $elem.data("synGraph");
    }
    static getAvailableLayouts($elem, options) {
        let layouts = [];
        for (let s in LayoutBase_1.GraphLayoutType) {
            let n = LayoutBase_1.GraphLayoutType[s];
            if (typeof n === "number")
                layouts.push({ id: n.toString(), name: Utilities_1.synUtil.Strings.getValue("graph.layout." + s.toString().toLowerCase()) });
        }
        return layouts;
    }
    static zoomFit($elem) {
        return $elem.each(function () {
            const layout = $(this).data("layout");
            if (layout)
                layout.zoomFit();
        });
    }
    static print($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let diagram = $this.getKendoDiagram();
            let oldPan = new kendo.dataviz.diagram.Point(diagram.scroller.scrollLeft, diagram.scroller.scrollTop);
            let oldZoom = diagram.zoom();
            Graph.zoomFit($this);
            let serializer = new XMLSerializer();
            let svgString = serializer.serializeToString($this.find("svg")[0]);
            if (kendo.support.browser.msie) {
                let windowTitle = Utilities_1.synUtil.Strings.getValue("graph.print");
                let win = window.open("", windowTitle, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=800, height=800");
                if (win) {
                    win.document.write(svgString);
                    win.document.body.innerHTML = svgString;
                    win.document.close();
                    diagram.zoom(oldZoom);
                    diagram.pan(oldPan);
                    win.focus();
                    win.print();
                    win.close();
                }
            }
            else {
                let hiddenFrame = document.createElement("iframe");
                hiddenFrame.style.visibility = "hidden";
                hiddenFrame.style.position = "fixed";
                hiddenFrame.style.right = "0";
                hiddenFrame.style.bottom = "0";
                document.body.appendChild(hiddenFrame);
                let doc = hiddenFrame.contentWindow ? hiddenFrame.contentWindow.document : undefined;
                if (doc) {
                    doc.open();
                    doc.write(svgString);
                    doc.close();
                }
                diagram.zoom(oldZoom);
                diagram.pan(oldPan);
                let closePrint = function () {
                    document.body.removeChild(this.__container__);
                };
                if (hiddenFrame.contentWindow) {
                    hiddenFrame.contentWindow.__container__ = hiddenFrame;
                    hiddenFrame.contentWindow.onbeforeunload = closePrint;
                    hiddenFrame.contentWindow.onafterprint = closePrint;
                    hiddenFrame.contentWindow.focus(); // Required for IE
                    hiddenFrame.contentWindow.print();
                }
            }
        });
    }
    static getCenterNode($elem) {
        return $elem.data("centerNode");
    }
    static getSelectedId($elem) {
        const kendoDiagram = $elem.getKendoDiagram();
        if (!kendoDiagram)
            return undefined;
        const selectedData = kendoDiagram.select();
        if (!selectedData.length)
            return undefined;
        return selectedData[0].dataItem.instance.id.value;
    }
    static arraysAreEqual(a, b) {
        if (a === b)
            return true;
        if (a == undefined) {
            if (b != undefined)
                return b.length === 0;
        }
        else if (b == undefined)
            return a.length !== 0;
        if (a.length !== b.length)
            return false;
        for (let i = 0; i < a.length; ++i)
            if (a[i] !== b[i])
                return false;
        return true;
    }
    static updateGraph($elem, id, forceRefetch) {
        let that = this;
        let handleGraph = (graph) => {
            $elem.getKendoDiagram().clear();
            if (graph && id)
                Graph.layoutGraph($elem, graph, id);
        };
        let oldGraph = $elem.data("graph");
        if (id && (!oldGraph || forceRefetch)) {
            if (!$elem.data("fetchingData")) {
                let options = $elem.data("synGraph");
                $elem.data("fetchingData", true);
                $elem.trigger("fetchGraphBegin");
                let completeEventRaised = false;
                Utilities_1.synUtil.getAJAXData({
                    requestData: JSON.stringify({
                        node: id,
                        parentDepth: options.layoutType === LayoutBase_1.GraphLayoutType.TdOrganigram ? 1 : options.parentDepth,
                        childDepth: options.layoutType === LayoutBase_1.GraphLayoutType.TdOrganigram ? 1 : options.childDepth,
                        allowedCategories: options.allowedCategories,
                        allowedRelIDs: options.allowedRelIds,
                        fetchUncles: options.layoutType === LayoutBase_1.GraphLayoutType.TdOrganigram ? false : options.fetchUncles
                    }),
                    url: Utilities_1.synUtil.getWSUrl("Graph"),
                    method: "POST",
                    done: (graph) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        $elem.trigger("fetchGraphComplete");
                        completeEventRaised = true;
                        for (let i = 0; i < graph.nodes.length; ++i)
                            graph.nodes[i].data.instance = yield Instance_1.Instance.fromJSON(graph.nodes[i].data.instance);
                        $elem.data("graph", graph); // "graph" enthält nun bei nodes[i].data.instance ein Objekt vom Typ Instance!
                        handleGraph(graph);
                    }),
                    cleanUp() {
                        if (!completeEventRaised)
                            $elem.trigger("fetchGraphComplete");
                        $elem.data("fetchingData", false);
                    }
                });
            }
        }
        else
            handleGraph(oldGraph);
        if (!id) {
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("InstanceChildrenTree"),
                requestData: {},
                done(data) {
                    $.address.parameter("id", data[0].id, false);
                    id = data[0].id;
                    that.navigateTo($elem, id, true);
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        }
    }
    static layoutGraph($elem, graph, centerNodeId) {
        let synData = $elem.data("synGraph");
        let layout;
        if (synData.layoutType === LayoutBase_1.GraphLayoutType.TdOrganigram)
            layout = new Organigramm_1.Organigramm($elem, centerNodeId);
        else
            layout = new KendoLayout_1.KendoLayout($elem, centerNodeId, synData.layoutType);
        $elem.trigger("renderBegin");
        $elem.data("layout", layout);
        layout.render(graph);
        $elem.trigger("renderComplete");
    }
}
(function ($) {
    $.fn.synGraph = function (method) {
        if (Graph[method])
            return Graph[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Graph.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synGraph");
    };
})(jQuery);
